import React, { createContext, useContext } from 'react';
import useDbManager from '../../routes/Setup/Database/DbManager/useDbManager';

type DbManagerContextType = ReturnType<typeof useDbManager>;

const DbManagerContext = createContext<DbManagerContextType | null>(null);

export function DbManagerProvider({ children }: { children: React.ReactNode }) {
    const value = useDbManager();
    return <DbManagerContext.Provider value={value}>{children}</DbManagerContext.Provider>;
}

export function useDbManagerContext(): DbManagerContextType {
    const ctx = useContext(DbManagerContext);
    if (!ctx) throw new Error('useDbManagerContext must be used within DbManagerProvider');
    return ctx;
}

export default DbManagerContext;
